import { render, staticRenderFns } from "./OrderOnBehalf.vue?vue&type=template&id=76fd11b2&scoped=true"
import script from "./OrderOnBehalf.vue?vue&type=script&lang=js"
export * from "./OrderOnBehalf.vue?vue&type=script&lang=js"
import style0 from "./OrderOnBehalf.vue?vue&type=style&index=0&id=76fd11b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd11b2",
  null
  
)

export default component.exports